// extracted by mini-css-extract-plugin
export default {"profile-container":"styles_profile-container__ctJHg","collapsed":"styles_collapsed__sTl+N"};